import React from 'react';

const AboutMe = () => {
    return (
        <section id="about-me" className="about-me-section bg-dark-blue" style={{ height: '30vh' }}>
    <h2 className="font-bold text-2xl mb-2">About Me</h2>
    <p>
      Software Engineer with a Master's in Computer Science from NTNU, specializing in <br />
      full-stack development and NLP research. I've built and optimized high-throughput <br />
      APIs at Whitson LLC, developed real-time traffic systems at Bouvet/Statens vegvesen, <br />
      and shipped full-stack web apps at Wiseline AS. My Master's thesis applied transformer <br />
      models to analyze extremist rhetoric across 1.2M+ social media records. <br />
      Beyond tech, I love travel, fitness, and exploring new cultures.
    </p>
</section>
    );
};

export default AboutMe;
